enum AttachmentMenuEntrySource {
    CommandingBar = 'CommandingBar',
    ToolBar = 'ToolBar',
}

export default AttachmentMenuEntrySource;
